import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlowerDaisy = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 22C21.1046 22 22 21.1046 22 20C22 18.8954 21.1046 18 20 18C18.8954 18 18 18.8954 18 20C18 21.1046 18.8954 22 20 22Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M31 20C31 18.7136 28.8901 17.6195 26.7764 17.1931C27.9695 15.3971 28.6879 13.1315 27.7782 12.2218C26.8685 11.3121 24.603 12.0305 22.8069 13.2236C22.3805 11.1099 21.2864 9 20 9C18.7136 9 17.6195 11.1099 17.1931 13.2236C15.397 12.0305 13.1315 11.3121 12.2218 12.2218C11.3121 13.1315 12.0305 15.3971 13.2236 17.1931C11.1099 17.6195 9 18.7136 9 20C9 21.2864 11.1099 22.3805 13.2235 22.8069C12.0305 24.603 11.3122 26.8685 12.2218 27.7781C13.1315 28.6878 15.397 27.9695 17.1931 26.7764C17.6195 28.8901 18.7136 31 20 31C21.2864 31 22.3805 28.8901 22.8069 26.7764C24.603 27.9695 26.8685 28.6878 27.7782 27.7781C28.6878 26.8685 27.9695 24.603 26.7765 22.8069C28.8901 22.3805 31 21.2864 31 20Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgFlowerDaisy);
export default ForwardRef;
